import core from '@gritdigital/ui/core';
import animate from '@gritdigital/ui/packages/animate';
import splide from '@gritdigital/ui/packages/splide';
import '@gritdigital/ui/packages/lite-players'
import LoadMore from './classes/load-more';
import { speculateLinks } from "@lucidclient/speculate";

animate.register({
    name: 'fade-in-left',
    reset: false,
    keyframes: {
      standard: [
        {
          transform: 'translateX(60px)',
          opacity: 0,
        },
        {
          transform: 'translateX(0)',
          opacity: 1,
        },
      ],
      reduced: [
        {
          opacity: 0,
        },
        {
          opacity: 1,
        },
      ],
    },
    initialState: {
      transform: 'translateX(60px)',
      opacity: 0,
    },
  })

animate.init({
    timing: {
        duration: 500,
    }
});
splide.init();
core.init();
speculateLinks();
new LoadMore();
